export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_SM = 325;
export const HEADER_HEIGHT = 64;
export const CONTENT_MAX_WIDTH = 1450;
